import { toast } from 'react-toastify';
import { resolveAssignAccountId } from './orderStagingAssignHelpers';

const INTEGRATION_ASSIGN_API_BASE = 'integration-assign/';

const getAuthHeaders = () => {
  const rawUser = sessionStorage.getItem('user');
  const user = rawUser ? JSON.parse(rawUser) : null;
  const token =
    user &&
    user.signInUserSession &&
    user.signInUserSession.idToken &&
    user.signInUserSession.idToken.jwtToken;
  return {
    'Content-Type': 'application/json',
    Authorization: token ? `Bearer ${token}` : '',
  };
};

const getRxNumberFromCartItem = (item) =>
  item.prescriptionNumber || item.prescriptionnumber || '';

const parseJsonResponse = (text) => {
  if (text == null || text === '') {
    return null;
  }
  try {
    let parsed = typeof text === 'string' ? JSON.parse(text) : text;
    if (typeof parsed === 'string') {
      parsed = JSON.parse(parsed);
    }
    return parsed;
  } catch (e) {
    return null;
  }
};

const parseIsRxExistsResponse = (text) => {
  const parsed = parseJsonResponse(text);
  if (!parsed) {
    return { Rx_Is_Exist: false };
  }
  if (parsed.status && String(parsed.status).toLowerCase() === 'failed') {
    return { Rx_Is_Exist: false };
  }
  return parsed;
};

const isRxAlreadyAssigned = (parsedResponse) =>
  parsedResponse &&
  (parsedResponse.Rx_Is_Exist === true || parsedResponse.Rx_Is_Exist === 'true');

const postIntegrationAssign = (path, body) =>
  fetch(process.env.REACT_APP_BASEURL + INTEGRATION_ASSIGN_API_BASE + path, {
    crossDomain: true,
    method: 'post',
    withCredentials: true,
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  }).then((response) => response.text());

const isBypassConsultEnabled = (accountDetails) =>
  !!(
    accountDetails &&
    (accountDetails.bypass_consult === true ||
      accountDetails.bypass_consult === 'true')
  );

const buildCartItemFromLookup = (parsedJson, prescriptionDetails, accountDetails) => {
  let isreturnable = false;
  if (prescriptionDetails && prescriptionDetails.IsReturnable === true) {
    isreturnable = prescriptionDetails.IsReturnable;
  }

  return {
    ndcCode: prescriptionDetails.ndc || '',
    amount_due: prescriptionDetails.amount_due,
    itemId: '',
    binId: '',
    rxNo: prescriptionDetails.rx_num || '',
    rx_no: prescriptionDetails.rx_num || '',
    name: prescriptionDetails.name,
    description: '',
    image: '',
    potency: '',
    qty: prescriptionDetails.dispensed_qty,
    schedule: '',
    Amount: prescriptionDetails.amount_due,
    taxPercentage: '',
    insuranceAmount: '',
    CoPayAmount: prescriptionDetails.amount_due,
    PaidAmount: '',
    DueAmount: '',
    paymentDueDate: '',
    stockedOn: '',
    stockedBy: '',
    deStockedOn: '',
    strength: '',
    route: '',
    doseage_form: '',
    non_proprietary_name: '',
    ExpirationDate: prescriptionDetails.expiry_date,
    isLoadingTrans: false,
    fillNumber: prescriptionDetails.fill_number,
    prescriptionNumber: prescriptionDetails.rx_num,
    prescriptionnumber: prescriptionDetails.rx_num,
    ConsultRequire:
      isBypassConsultEnabled(accountDetails)
        ? false
        : prescriptionDetails.fill_number === 0 ||
          prescriptionDetails.fill_number === '0',
    // Auto first-fill / lookup path — never treat as manual staff intent (DI-6213).
    consultRequireManual: false,
    IsReturnable: isreturnable,
    status: '',
    order_id: parsedJson.order_id,
    prescription_txn_id: prescriptionDetails.prescription_txn_id || '',
  };
};

const applyPartnerIntegrationLookupToUi = (component, patient, cartItems) => {
  const { boxDetails } = component.state;
  const boxId = component.state.box_id;

  let AddressLine1 = '';
  let AddressLine2 = '';
  let City = '';
  let State = '';
  let Zip = '';
  let Country = '';

  const locationDetails = (boxDetails || []).filter((x) => x.id === boxId)[0];
  if (![undefined, 'undefined', null, 'null', ''].includes(locationDetails)) {
    AddressLine1 = locationDetails.address_line_1 || '';
    AddressLine2 = locationDetails.address_line_2 || '';
    City = locationDetails.city || '';
    State = locationDetails.state || '';
    Zip = locationDetails.zip || '';
    Country = locationDetails.country || '';
  }

  const parsedDob = patient.dob_str || patient.DateOfBirth || patient.dob || '';
  const phoneNumber = patient.phone || patient.MobileNo || 'N/A';
  const emailAddress = patient.EmailAddress || patient.email || 'N/A';

  if (patient.address_line_1) {
    AddressLine1 = patient.address_line_1 || '';
    AddressLine2 = patient.address_line_2 || '';
    City = patient.city || '';
    State = patient.state || '';
    Zip = patient.zip || '';
  }

  try {
    component.generateCodes();
  } catch (e) {
    console.warn('generateCodes skipped:', e);
  }

  const cartSnapshot = [...cartItems];

  component.setState({
    locationtype_id: localStorage.getItem('selectedLocationTypeId'),
    box_id: boxId,
    searchedItems: {
      PatientID:
        patient.PatientID ||
        patient.MedicalRecordNumber ||
        patient.patient_id ||
        patient.patientID ||
        patient.ExternalPatientID,
      customer_id: patient.customer_id || patient.customerId,
      FirstName: patient.FirstName || patient.first_name || patient.firstName,
      LastName: patient.LastName || patient.last_name || patient.lastName,
      MiddleName: patient.MiddleName || null,
      DateOfBirth: parsedDob,
      MobileNo: phoneNumber,
      EmailID: emailAddress,
      AddressLine1,
      AddressLine2,
      City,
      State,
      Zip,
      Country,
      notes: (patient && patient.notes) || '',
      orders: [{ items: cartSnapshot }],
    },
    patientNotes: (patient && patient.notes) || '',
    basicDetails: {
      first_name: patient.FirstName || patient.first_name || patient.firstName,
      last_name: patient.LastName || patient.last_name || patient.lastName,
      dob_str: patient.DateOfBirth || patient.dob || parsedDob,
    },
    contactDetails: {
      phone: phoneNumber,
      email: emailAddress,
    },
    EmailID: emailAddress,
    phone: phoneNumber,
    rxNumber: '',
    loader: false,
    assignCartItems: cartSnapshot,
  });
};

const getSearchedRxItems = (component) => component.getSearchedRxItems();

const addLookupResultToCart = (component, item, patientDetails, searchedString) => {
  const searchedRxItems = getSearchedRxItems(component);
  const existingItem = component.state.searchedItems;
  const hasCartItems = searchedRxItems && searchedRxItems.length > 0;
  const hasExistingPatient =
    existingItem &&
    !Array.isArray(existingItem) &&
    (existingItem.PatientID || existingItem.patient_id);

  if (hasCartItems && hasExistingPatient) {
    const existingPatientId = existingItem.PatientID || existingItem.patient_id;
    const newPatientId = patientDetails.patient_id || patientDetails.PatientID;
    if (existingPatientId !== newPatientId) {
      toast.error(component.props.t('Toast.Error.WrongPatient'));
      component.setState({ rxNumber: '', loader: false });
      return;
    }

    const dedupeKey = getRxNumberFromCartItem(item) || searchedString;
    const isexist = searchedRxItems.findIndex(
      (x) => getRxNumberFromCartItem(x) === dedupeKey
    );
    if (isexist >= 0) {
      toast.error(component.props.t('Toast.Error.RxAddedToCart'));
      component.setState({ rxNumber: '', loader: false });
      return;
    }
  }

  searchedRxItems.push(item);

  try {
    if (patientDetails && patientDetails.patient_id && patientDetails.EmailAddress) {
      component.checkADACompatible(
        patientDetails.patient_id,
        patientDetails.EmailAddress
      );
    }
  } catch (e) {
    console.warn('checkADACompatible skipped:', e);
  }

  applyPartnerIntegrationLookupToUi(component, patientDetails, searchedRxItems);
};

const processLookupResponse = (
  component,
  accountDetails,
  parsedJson,
  searchedString
) => {
  if (
    parsedJson &&
    parsedJson.status &&
    String(parsedJson.status).toLowerCase() === 'failed'
  ) {
    toast.error(parsedJson.error_message || 'Order lookup failed.');
    component.setState({ rxNumber: '', loader: false });
    return;
  }

  if (!parsedJson || !parsedJson.order_details) {
    toast.error(component.props.t('Toast.Error.RxFound'));
    component.setState({ rxNumber: '', loader: false });
    return;
  }

  const patientDetails = parsedJson.patient;
  const prescriptionDetails = parsedJson.order_details;

  if ([false, 'false'].includes(patientDetails && patientDetails._isOrderFound)) {
    toast.error('This order may not be deliverable.', {
      autoClose: 5000,
      progress: undefined,
      hideProgressBar: false,
    });
  }

  const item = buildCartItemFromLookup(
    parsedJson,
    prescriptionDetails,
    accountDetails
  );
  addLookupResultToCart(component, item, patientDetails, searchedString);
};

export const handleIntegrationAssignRxOnChange = (component, e) => {
  const scannedValue = e.target.value;
  const cleanedValue = String(scannedValue).replace(/^0+/, '');

  component.setState(
    {
      rxNumber: cleanedValue,
      isEdit: false,
      doesPrescriptionScanned: true,
    },
    () => {
      console.log(component.state.doesPrescriptionScanned);
    }
  );
};

export const handleIntegrationAssignRxKeyDown = async (component, event) => {
  const { accountDetails } = component.state;
  const isEnter = event.key === 'Enter' || event.keyCode === 13;
  if (!isEnter) {
    return;
  }

  event.preventDefault();

  const accountId = resolveAssignAccountId(component);
  if (!accountId) {
    toast.error('Account is not loaded. Please refresh the page and try again.');
    return;
  }

  const searchedString = String(
    component.state.rxNumber || event.target.value || ''
  ).trim();
  if (!searchedString) {
    return;
  }

  component.setState({ loader: true, isEdit: false });

  try {
    let parsedRxCheck = { Rx_Is_Exist: false };
    try {
      const rxRes = await postIntegrationAssign('is-rx-exists', {
        rxNumber: searchedString,
        account_id: accountId,
      });
      parsedRxCheck = parseIsRxExistsResponse(rxRes);
    } catch (rxCheckError) {
      console.warn('is-rx-exists check failed, continuing to lookup:', rxCheckError);
    }

    if (isRxAlreadyAssigned(parsedRxCheck)) {
      toast.error(component.props.t('Toast.Error.RxExist'));
      component.setState({ rxNumber: '', loader: false });
      return;
    }

    const lookupRes = await postIntegrationAssign('orders/lookup', {
      lookupValue: searchedString,
      account_id: accountId,
    });
    const parsedJson = parseJsonResponse(lookupRes);

    try {
      processLookupResponse(component, accountDetails, parsedJson, searchedString);
    } catch (uiError) {
      console.error('Integration assign UI update failed:', uiError);
      toast.error(
        'Prescription was found but could not be loaded. Please refresh and try again.'
      );
      component.setState({ rxNumber: '', loader: false });
    }
  } catch (error) {
    console.error('Integration assign scan failed:', error);
    toast.error('Unable to look up prescription. Please try again.');
    component.setState({ rxNumber: '', loader: false });
  }
};



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/integration-assign/integrationAssignHandlers.js